import { useEffect, useState } from "react";

// Mirror of ContentShell's expanded-column state (the source of truth is the
// shell's `data-column-expanded` dataset). Listens on window — the
// `columnexpandchange` event bubbles — rather than on the shell node itself:
// the shell can be REPLACED across scope/lens changes, and a listener bound
// to the old node goes deaf, freezing the mirror at "expanded" and anything
// deriving layout from it (SplitPage's two-column width) along with it. The
// dataset is re-read from the live document on every event because the node
// that dispatched it may not be the node that exists by the next one.
export function useExpandedColumnMirror() {
  const [expandedColumnId, setExpandedColumnId] = useState(null);
  useEffect(() => {
    const sync = () => {
      const shell = document.querySelector("[data-shell]");
      setExpandedColumnId(shell?.dataset.columnExpanded || null);
    };
    window.addEventListener("columnexpandchange", sync);
    const raf = requestAnimationFrame(sync);
    return () => { window.removeEventListener("columnexpandchange", sync); cancelAnimationFrame(raf); };
  }, []);
  return expandedColumnId;
}
